/* Date fields of a post's postDescription, normalized into new objects.
 *
 * Posts reach the config forms as props: either a layout template from the
 * getPageLayout query or a stored post. Apollo hands out its cached results
 * deep-frozen, so the old habit of shallow-copying the post and then writing
 * postDescription.date in place threw "Cannot assign to read only property
 * 'date'" and broke the choose-layout screen. These helpers copy every level
 * they touch and never write to the object they are given.
 *
 * The stored value is a millisecond timestamp (as a string, from the JSON
 * scalar); the forms want an ISO string. A value that isn't a number - already
 * ISO, or absent - is left as it is. */

const transformTimesStampToIsoDate = date => (Number(date) ? new Date(Number(date)).toISOString() : date ?? null);

// Editing an existing post: every date it may carry becomes an ISO string.
const withIsoDates = (post) => {
  const postDescription = post.postDescription || {};

  return {
    ...post,
    postDescription: {
      ...postDescription,
      date: transformTimesStampToIsoDate(postDescription.date),
      launcherSortDate: transformTimesStampToIsoDate(postDescription.launcherSortDate),
      expirationDate: transformTimesStampToIsoDate(postDescription.expirationDate),
    },
  };
};

// Creating a post from a layout template: only the publication date matters,
// and a template that carries none starts at "now".
const withCreationDate = (post, nowIsoDate = new Date().toISOString()) => {
  const postDescription = post.postDescription || {};

  return {
    ...post,
    postDescription: {
      ...postDescription,
      date: transformTimesStampToIsoDate(postDescription.date) || nowIsoDate,
    },
  };
};

module.exports = { transformTimesStampToIsoDate, withIsoDates, withCreationDate };
